import { BotonExportarExcel, Group, TablaSkeleton, Table, Tbody, Th, Thead, Tr } from "@/components/ui";
import { formatFecha } from "@/shared/format/fecha";
import type { ClaveSatAdmin } from "../services/claves-sat-admin-service";
import { ClaveSatRow } from "./ClaveSatRow";

export function ClavesSatTable({
  cargando = false,
  claves,
  obtenerFilas,
}: {
  /** Primera carga (sin caché) · filas skeleton bajo el encabezado real. */
  cargando?: boolean;
  claves: ClaveSatAdmin[];
  /** Trae TODAS las páginas con los filtros actuales · para el export. */
  obtenerFilas: () => Promise<ClaveSatAdmin[]>;
}) {
  return (
    <div className="overflow-x-auto">
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo="claves-sat"
          hoja="Claves SAT"
          obtenerFilas={obtenerFilas}
          columnas={[
            { header: "Clave", value: (c) => c.clave },
            { header: "Descripción", value: (c) => c.descripcion },
            { header: "Incluir IVA trasladado", value: (c) => c.incluirIvaTrasladado ?? "" },
            { header: "Incluir IEPS trasladado", value: (c) => c.incluirIepsTrasladado ?? "" },
            { header: "Complemento que debe incluir", value: (c) => c.complementoQueDebeIncluir ?? "" },
            { header: "Fecha inicio vigencia", value: (c) => (c.fechaInicioVigencia ? formatFecha(c.fechaInicioVigencia) : "") },
            { header: "Fecha fin vigencia", value: (c) => (c.fechaFinVigencia ? formatFecha(c.fechaFinVigencia) : "") },
            { header: "Estímulo franja fronteriza", value: (c) => (c.estimuloFranjaFronteriza ? "Sí" : "No") },
            { header: "Palabras similares", value: (c) => c.palabrasSimilares ?? "" },
            { header: "Estado", value: (c) => (c.utilizable ? "Vigente" : c.vigente ? "Fuera de vigencia" : "Descontinuada") },
          ]}
        />
      </Group>
      <Table verticalSpacing="sm">
        <Thead>
          <Tr>
            <Th>Clave</Th>
            <Th>Descripción</Th>
            <Th>IVA trasladado</Th>
            <Th>IEPS trasladado</Th>
            <Th>Vigencia</Th>
            <Th>Franja fronteriza</Th>
            <Th>Palabras similares</Th>
            <Th>Estado</Th>
            <Th />
          </Tr>
        </Thead>
        {cargando ? (
          <TablaSkeleton dentroDeTabla columnas={[{}, {}, {}, {}, {}, {}, {}, {}, { align: "right" }]} filas={15} />
        ) : (
          <Tbody>
            {claves.map((c) => (
              <ClaveSatRow key={c.clave} clave={c} />
            ))}
          </Tbody>
        )}
      </Table>
    </div>
  );
}
